module.exports = __webpack_public_path__ + "media/images/admin/icons/meh-2b37a9a33d34ffeb18067f7e3e4500ec.svg";